import React from "react";
import { useTranslation, Link } from "gatsby-plugin-react-i18next";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import ConditionalLink from "components/ConditionalLink";
import { renderForMobile } from "utils/renderForMobile";
import cx from "classnames";

const Footer = ({
  className,
  propertyLogoDesktop,
  propertyLogoMobile,
  groupLogo,
  socialMediaLabel,
  socialMedia,
  menus,
  destinationCards,
  otherMenus,
  propertyUrl,
  multiLogo,
  otherLogos,
  location,
}) => {
  const { t } = useTranslation("homepage");
  const breakpoints = useBreakpoint();

  return (
    <footer className="w-max-1240 mx-auto px-20 lg:px-100 lg:pt-60 lg:pb-20 pt-40 pb-20 bg-solid-white antialiased">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-16">
        <div>
          <div
            className={cx("mx-auto lg:ml-0 lg:pb-30", {
              "w-272": multiLogo,
              "w-auto lg:w-225": !multiLogo,
            })}>
            <ConditionalLink
              className={cx("flex space-x-10", multiLogo)}
              link={propertyUrl}
              sameTab={true}>
              {renderForMobile(breakpoints)
                ? propertyLogoMobile
                : propertyLogoDesktop}
            </ConditionalLink>
          </div>
          <div className="grid grid-cols-2 gap-x-24 lg:gap-x-0 md:grid-cols-3 lg:gap-y-18 gap-y-30 pb-30 lg:pt-0 pt-30">
            {menus &&
              menus.map((menu) => (
                <div
                  key={menu.name}
                  className="text-12-22 font-bold md:font-semibold font-mulish uppercase text-gray-text lg:pl-0 pl-30 tracking-24 lg:tracking-16">
                  <ConditionalLink link={menu.link} external={menu.newTab}>
                    {t(menu.name)}
                  </ConditionalLink>
                </div>
              ))}
          </div>
          <div className="grid lg:flex lg:justify-start lg:py-0 py-30 lg:border-0 border-t border-b border-gray-border">
            <div className="mb-16 lg:mb-0 lg:flex lg:items-center uppercase text-gray-text font-bold text-14-22 lg:text-12-22 text-center lg:text-left tracking-8">
              {socialMediaLabel}
            </div>
            <div className="flex flex-wrap justify-center align-center -mx-5 lg:mx-10">
              {socialMedia &&
                socialMedia.map((obj, index) => (
                  <div
                    key={index}
                    className="w-32 h-32 lg:w-24 lg:h-24 m-5 flex align-center justify-center">
                    {obj}
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="lg:ml-auto">
          <div className="w-full mx-auto lg:ml-0 lg:mt-0 mt-14 mb-16 lg:mb-24">
            {otherLogos}
          </div>
          <div className="pt-10 pb-16 lg:pb-20 lg:pt-10 uppercase text-center text-gray-text lg:text-left lg:text-12-22 text-14-22 font-bold tracking-8">
            {t("Destinations")}
          </div>
          <div className="lg:h-160">
            <div className="grid grid-flow-cols auto-cols-max lg:grid-cols-3 grid-cols-1 lg:gap-x-10 lg:gap-y-0 gap-y-10 lg:w-500">
              {destinationCards && destinationCards.map((card) => card)}
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-y-16 lg:mt-20 lg:border-t lg:border-gray-disable-bg lg:pt-10">
        <div className="text-center lg:text-left font-mulish text-12-22 text-gray-dark text-opacity-90 relative bottom-0 pt-30 lg:pt-0 mb-80 lg:mb-0 tracking-2">
          {location === "Bali"
            ? `© ${new Date().getFullYear()} PT Karang Mas Sejahtera. All Rights Reserved`
            : `© ${new Date().getFullYear()} ${t("RightsReserved")}`}
        </div>
        <div className="hidden lg:block font-mulish text-12-22 text-gray-dark text-opacity-90 relative bottom-0">
          <div className="uppercase text-10-22 font-semibold text-opacity-90 text-right tracking-16">
            {otherMenus && otherMenus.map((menu) => menu)}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
